import React, { useEffect } from 'react';
import Hero from './Hero';
import LivePreview from './LivePreview';
import BuyerJourney from './BuyerJourney';
import CTABanner from './CTABanner';
import Footer from '../../Footer';

const RealEstateListingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ fontFamily: "'Montserrat', Helvetica, Arial, sans-serif" }}>
      <Hero />
      <LivePreview />
      <BuyerJourney />
      <CTABanner />
      <Footer />
    </div>
  );
}

export default RealEstateListingPage;
